import { Button, Modal, Table } from 'antd'
import React, { Component, Fragment } from 'react'
import { Link } from 'react-router-dom'

export default class KitsToChangeModal extends Component {

    constructor(props) {
        super(props)
        this.state = {
            kitsToChange: this.props.kitsToChange,

            kitsToChangeModal: false,
        }
    }

    componentWillReceiveProps = (nextProps) => {
        if (nextProps.kitsToChange !== this.state.kitsToChange)
            this.setState({ kitsToChange: nextProps.kitsToChange })
    }

    render() {
        return (
            <Fragment>

                <span
                    className='link-style'
                    onClick={() => this.setState({ kitsToChangeModal: true })}
                >Ver fichas(s)</span>

                <Modal
                    visible={this.state.kitsToChangeModal}
                    title='Fichas que serão atualizadas'
                    onCancel={() => this.setState({ kitsToChangeModal: false })}
                    footer={[
                        <Button
                            onClick={() => this.setState({ kitsToChangeModal: false })}
                        >Fechar</Button>
                    ]}
                    width={800}
                >
                    <Table
                        columns={[
                            {
                                title: 'Código',
                                key: 'code',
                                dataIndex: 'code',
                            },
                            {
                                title: 'Descrição',
                                key: 'name',
                                dataIndex: 'name',
                            },
                            {
                                title: 'Detalhe',
                                key: 'details',
                                dataIndex: 'details',
                                render: (v, _) => {
                                    return (
                                        <Link
                                            to={`/panel/kit/editar/${_.objectId}`}
                                            target='_blank'
                                        >
                                            <Button icon='eye' />
                                        </Link>
                                    )
                                }
                            }
                        ]}
                        dataSource={this.state.kitsToChange.map(el => el.toJSON())}
                        locale={{ emptyText: "Nenhuma ficha encontrada." }}
                    />
                </Modal>
            </Fragment>
        )
    }

}